/**
 * Hoạt động thu
 * bdanh 05.02.2023
 */
export default {
  Career: 1, //sự nghiệp
  Service: 2, //dịch vụ
};
